import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AtestadosComponent } from './atestados.component';
import { EditAtestadoComponent } from './components/edit-atestado/edit-atestado.component';

const routes: Routes = [
  {
    path: '',
    component: AtestadosComponent
  },
  {
    path: ':id',
    component: EditAtestadoComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AtestadosRoutingModule {}
